import React from 'react';
import { useSelector } from 'store';
import moment from 'moment';
import FeedImageSlider from 'components/community/components/feed/FeedImageSlider';
import { LatLng } from 'constants/type';
import LocalStitchMap from 'components/common/LocalStitchMap';
import { useRouter } from 'next/router';

const SpaceFeedDetailService: React.FC = () => {
  const feed = useSelector(state => state.community.branch_post);
  const { branch } = feed;
  const DATE_FORMAT = 'YYYY.MM.DD hh:mm';
  const router = useRouter();

  const mapCenter: LatLng = {
    lat: Number(branch.latitude),
    lng: Number(branch.longitude),
  };

  const clickBranch = () => {
    router.push(`/branch/place/${branch.id}`);
  };

  return (
    <div className="cnts-wrap">
      <div className="s-menu">
        <ul>
          <li className="selected">
            <a>{branch.region.name}</a>
          </li>
        </ul>
      </div>
      <div className="activity-list feed-detail">
        <div className="spot-info noline">
          <div className="hgroup">
            <h3 onClick={clickBranch} style={{ cursor: 'pointer' }}>
              {branch.name}
            </h3>
            <p>{moment(feed.created_at).format(DATE_FORMAT)}</p>
          </div>
        </div>
        <div className="photo-w">
          <FeedImageSlider images={feed.images} />
        </div>
        <div className="guide-detail">
          <div dangerouslySetInnerHTML={{ __html: feed.content }} />
        </div>
        <LocalStitchMap
          center={mapCenter}
          zoom={15}
          branches={[branch]}
          height="30vh"
        />
      </div>
    </div>
  );
};

export default SpaceFeedDetailService;
